module.exports = __webpack_public_path__ + "img/step_3.eafe5f01.png";